import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React from "react";

export default function AdminPuzzleMain() {
    return (
        <Box>
            <Box
                sx={{
                    height: "300px",
                    backgroundImage: "url(/bg_images/writing_word.jpeg)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    fontSize: "24px",
                }}
            />
            <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
                Always think about what's best for the customer. Focus on fun and creativity.
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>Great ideas come all the time.</Typography>

            <Paper elevation={2} sx={{ p: 3, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#333' }}>
                    Puzzle Types
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: '#1976d2' }}>
                        Word Grid
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', pl: 2 }}>
                        Word Grid is the name for both <strong>Word Search</strong> and <strong>Hidden Message</strong> puzzles. Words are placed in a grid and can be found in various directions.
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: '#1976d2' }}>
                        Crossword
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', pl: 2 }}>
                        Crossword: Words are placed in two directions - horizontal (left to right) and vertical (top to bottom). Words intersect with each other to form a grid pattern.
                    </Typography>
                </Box>
            </Paper>
        </Box>
    );
}
